import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  Output,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import {
  Router,
  Event,
  NavigationEnd,
} from '@angular/router';

import { REACTEVENTS } from 'src/app/react-events';
import { Subject, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { resolveHostedUrl } from 'src/app/constants/hosted-api-urls';
import { UtilService } from 'src/app/util/util.service';
import { CommonService } from '../services/common.service';
import { ApiService } from '../../common/services/api.service';
import { takeUntil } from 'rxjs/operators';
import { ThemeService } from '../theme/theme.service';
import { FormControl } from '@angular/forms';
import { EasyEatHqService } from '../services/ee-hq.service';
import { AuthService } from '../../common/services/auth.service';
import { LocalStorageService } from '../services/localStorage.service';
import { PusherEventService } from '../services/pusher-event.service';
import { Event as EventList, MType as MtypeList } from 'src/app/pusher-event';
import { EventTrackerService } from '../services/event-tracker.service';
import { OrderStateService } from 'src/app/order/order-state.service';
import { OrderReactEventService } from 'src/app/order/order-reactevent.service';
import { LanguageService } from '../services/language.service';
import { membership } from '../enums/membership.enum';

import {
  RESTAURANT,
  EE_HQ,
  NAV_ORDER,
  INVOICE,
  DINING_ROOM,
  STORE,
  TABLE_RESERVATION,
  DINING_TABLE,
  KITCHEN,
  NAV_MENU,
  ANALYTICS,
  NAV_STAFF,
  SETTLEMENT,
  NAV_SECTION,
  NAV_LAYALTY_SETTING,
  REFERRAL_SIDENAV,
  MARKETING,
  INVENTORY,
  DISCOUNT_SIDENAV,
  INTEGRATION,
  COGWHEEL,
  QUESTION,
  LOGIN,
  LOGOUT,
  TABLE_BOOKING_ICON,
  RED_LOCK_ICON,
  AI_SIDENAV_ICON,
  INVOICE_ICON
} from 'src/defaultImages.js';
import { country } from '../enums/language';
import { AUTH_ENUM } from '../enums/auth.enum';
import { TableBookingHelperService } from 'src/app/table-bookings/services/table-bookings-helper.service';
import { TableBookingApiService } from 'src/app/table-bookings/services/table-bookings-api.service';
import { TranslateService } from '@ngx-translate/core';
import { AnimationControlService } from '../services/animation-control.service';
import { MessageService } from '../services/message.service';
import { ANIMATION_CONTROL_SUBJECT } from '../enums/animation-control.enum';
import { CollectionInfrastructureModalService } from 'src/app/collection-infrastructure/collection-infrastructure-modal.service';
import { LOCKED_FEATURE_TYPE } from 'src/app/collection-infrastructure/collection-infrastructure.enums';
import { CollectionInfrastructureHelperService } from 'src/app/collection-infrastructure/collection-infrastructure-helper.service';
import { BillingCountersDataService } from '../services/billing-counters-data.service';
import { DateService } from '../services/date.service';
import { AudioService } from '../services/audio.service';
import { NudgeService } from '../services/nudge.service';

declare function send_data(params: string): any;
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
})
export class SidenavComponent implements OnInit, OnDestroy {
  images = {
    RESTAURANT: RESTAURANT,
    EE_HQ: EE_HQ,
    NAV_ORDER: NAV_ORDER,
    INVOICE: INVOICE,
    TABLE_RESERVATION,
    DINING_ROOM: DINING_ROOM,
    STORE: STORE,
    DINING_TABLE: DINING_TABLE,
    KITCHEN: KITCHEN,
    NAV_MENU: NAV_MENU,
    ANALYTICS: ANALYTICS,
    NAV_STAFF: NAV_STAFF,
    SETTLEMENT: SETTLEMENT,
    NAV_SECTION: NAV_SECTION,
    NAV_LAYALTY_SETTING: NAV_LAYALTY_SETTING,
    REFERRAL_SIDENAV: REFERRAL_SIDENAV,
    MARKETING: MARKETING,
    INVENTORY: INVENTORY,
    DISCOUNT_SIDENAV: DISCOUNT_SIDENAV,
    INTEGRATION: INTEGRATION,
    COGWHEEL: COGWHEEL,
    QUESTION: QUESTION,
    LOGIN: LOGIN,
    LOGOUT: LOGOUT,
    TABLE_BOOKING_ICON: TABLE_BOOKING_ICON,
    RED_LOCK_ICON,
    AI_SIDENAV_ICON,
    INVOICE_ICON: INVOICE_ICON
  };
  restaurantDetails: any = {};
  isUserLoggedInSn = null;
  user_type = '';
  restaurant_name = '';
  restaurantid: string;
  public currentUrl: string;
  public noOfNewOrders: number;
  newTableEvents: number;
  restaurantId: string;
  allNotification: {
    table_no: string;
    floor_name: string;
    username: string;
    message_id: string;
    order_id: string;
    time_stamp: number;
    time_text: string;
  }[] = [];
  validOrders = [];
  isMobile: boolean;
  isKiosk: any;
  isKioskChild: boolean = false;
  onGoingRequest = 0;
  isSettlement = 0;
  showFoodCourtSettlment:boolean = false;
  restSettings: any = {};
  private ngUnsubscribe = new Subject();
  @Output() change = new EventEmitter();
  @Output() onToggleCollapse = new EventEmitter();
  darkTheme = new FormControl(false);
  isHqUser: boolean = false;
  isLockEnabled = 0;
  validUrl = {
    billing: true,
    report: true,
    'section-printer': true,
    loyalty: true,
    referral: true,
    inventory: true,
    promotion: true,
    'table-service': true,
    'table-bookings': true,
    'ai-insights': true,
    analytics: true,
    menu: true,
    ee_hq: true,
    hq_outlets: true,
    settlement: true,
    staff_center: true,
    pending_orders: true,
    'e-invoice': true
  };
  hqSideNavRoutes = [];
  navHeads = [
    {
      permission: 'CAN_VIEW_RESTAURANT_DETAILS',
    },
    {
      permission: 'CAN_VIEW_RESTAURANT_CHARGES',
    },
    {
      permission: 'CAN_VIEW_OFFLINE_PLATFORM',
    },
    {
      permission: 'CAN_VIEW_RESTAURANT_MISC_SETTINGS',
    },
    {
      permission: 'CAN_VIEW_RESTAURANT_POS_DEVICES',
    },
  ];
  isCollapsed: boolean;
  outletList = JSON.parse(localStorage.getItem('ee_outlets'));
  isAtleastSettlementEnabled: boolean = false;
  hqFcShowOrderDashBoard: boolean = false;
  showReferralProgram: boolean = false;
  isFoodCourtViewEnabled: boolean = false;
  hqLogo: string;
  allOutletListIds = [];
  allFoodCourtOrderCount: number = 0;
  isPrepaidOrderingEnabled: boolean = false;
  validPrepaidOrderTypes: Array<number> = [];
  isAutoRefreshEnabled: boolean = false;
  isHQCmmActive: boolean = false;
  viewCentralMenu: boolean = false;
  pricing: boolean = false;
  hqPricing: boolean = false;
  atleastOneProSubs: boolean = false;
  idCountry: boolean = false;
  showPromotionsOnPos: boolean = true;
  isKioskHq;
  isReactDevice: boolean;
  isFoodCourt;
  isIdEnvironment;
  isMyEnvironment;
  isTableReservationEnabled: boolean = false;
  subscription = new Subscription();
  tableBookingLength: number = 0;
  selectedDate;
  translationText: any;
  nudgeTableBooking = false;
  reservationSettings: any;
  kioskCashReport: boolean = false;
  isEEFreeDigitalMenuLeads: boolean = false;
  billingCounterName: string = '';
  constructor(
    private router: Router,
    private http: HttpClient,
    public utilService: UtilService,
    private commonService: CommonService,
    private apiService: ApiService,
    private themeService: ThemeService,
    private hqService: EasyEatHqService,
    private authService: AuthService,
    private _pusherEvent: PusherEventService,
    private _localStorage: LocalStorageService,
    private _eventTracker: EventTrackerService,
    private _orderState: OrderStateService,
    private _orderReactEvent: OrderReactEventService, // private _cdr: ChangeDetectorRef
    private _lang: LanguageService,
    private _cdr: ChangeDetectorRef,
    private translateService: TranslateService,
    private _tbHelperService: TableBookingHelperService,
    private _tbApiService: TableBookingApiService,
    private _translateService: TranslateService,
    private _animationControlService: AnimationControlService,
    private _msgService: MessageService,
    private _ciModalService: CollectionInfrastructureModalService,
    private _ciHelperService: CollectionInfrastructureHelperService,
    private _counterDataService: BillingCountersDataService,
    private _dateService: DateService,
    private _audioService: AudioService,
    private _nudgeService: NudgeService
  ) {
    this.isKioskHq = this.utilService.getIsKioskHq();
    this.isReactDevice = !!this.utilService.isReactDevice();
    this.isFoodCourt = this.utilService.getIsFoodcourtHq();
    this.isIdEnvironment = this.utilService.isIdEnvironment();
    this.isMyEnvironment = this.utilService.isMyEnvironment();
    this.selectedDate = this._dateService.getToday();
    this.isEEFreeDigitalMenuLeads = this.utilService.isEEFreeDigitalMenuLeads()
    router.events.subscribe((event: Event) => this.url_changed(event));
    this.onResize();
    this.darkTheme.valueChanges.subscribe((value) => {
      if (this.themeService.isDarkTheme()) {
        this.themeService.setLightTheme();
      } else {
        this.themeService.setDarkTheme();
      }
    });
    this.isHqUser = this.hqService.isHqUser();
    this.showFoodCourtSettlment = this.utilService.showFoodCourtSettlment() ?? false;
    try {
      this.isAtleastSettlementEnabled = this.isHqUser
        ? this.outletList.some(this.isSettlementVisible)
        : false;
    } catch {}

    this.subscription.add(
      this.translateService.get(['SIDENAV']).subscribe((translation) => {
        this.translationText = translation.SIDENAV;
      })
    );
  }
  getReservationSettings() {
    const restSettings = this.utilService.getRestaurantSettings() || {};
    this.reservationSettings = restSettings.reservation || {};
  }
  isSettlementVisible(x) {
    if (((x || {}).settings || {}).settlement.visible) return true;
  }
  showLoyalty = false;
  hideTooltip: boolean = false;
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    let innerWidth = window.innerWidth;
    if (innerWidth < 768) this.isMobile = true;
    else this.isMobile = false;
    this.hideTooltip = true;
  }
  ngOnInit() {
    this.isKioskChild = this.utilService.isKioskChild();
    this.setTranslations();
    this.showPromotionsOnPos = this.utilService.showPromotionsOnPos();
    this.hqPricing = this.utilService.litePricingHq();
    this.atleastOneProSubs = this.atleastOneProSubsChecker();
    this.hqFcShowOrderDashBoard = !!((JSON.parse(
      localStorage.getItem('hq_settings')
    ) || {})['global'] || {})['show_order_dashboard'];
    this.showReferralProgram = this.utilService.getShowReferralProgram();
    try {
      this.isFoodCourtViewEnabled = !!JSON.parse(
        localStorage.getItem('fc_rest_ids') || '[]'
      );
      this.isAutoRefreshEnabled = !!((JSON.parse(
        localStorage.getItem('restaurant_settings')
      ) || {})['global'] || {})['auto_refresh'];
    } catch {}
    if(this.isHqUser) {
      const userPermissions = JSON.parse(
        this._localStorage.get('user_permissions') || '[]'
      );
      if (userPermissions) {
        this.viewCentralMenu = userPermissions.includes(
          AUTH_ENUM.CAN_VIEW_HQ_MENU
        );
      }
    this.isHQCmmActive = !!((JSON.parse(localStorage.getItem('hq_settings') || '{}'))['menu'] || {})['cmm_enable'];
    } else {
      this.getAllTableBookings();
    }
    this.hqLogo = localStorage.getItem('hq_logo');
    this.allOutletListIds = (this.outletList || []).map((item) => item['id']);
    this.isCollapsed = localStorage.getItem('sidenavCollapsed') === 'true';
    this.onToggleCollapse.emit({ isCollapsed: this.isCollapsed });
    if (localStorage.getItem('token')) {
      this.isUserLoggedInSn = true;
      this.user_type = localStorage.getItem('user_type');
      this.restaurant_name = localStorage.getItem('restaurant_name');
      this.restaurantid = localStorage.getItem('restaurant_id');
      this.get_notification();
      this.getRestaurantDetails();
      if (this.user_type === 'MM') {
        this.noOfNewOrders = 0;
      }
      this.onGoingRequest = 0;
      this.commonService.edit$
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((message) => {
          if (message === 'tableservice updated') {
            this.get_notification();
          } else if (message == 'order completed') {
            this.calculateRunningOrders();
          }
        });
      if (this.isHqUser) {
        this.watchHQFoodCourtEvents();
        this.calculateAllFoodCourtOrders();
      } else {
        this.watchPusherEvents();
        this.calculateRunningOrders();
      }
      this.setRestSettingVar();
      this.setValidURL();

      this._localStorage.watch('user_permissions').subscribe((_) => {
        this.setValidURL();
      });
    } else {
      this.isUserLoggedInSn = false;
      this.user_type = '';
      this.restaurant_name = '';
    }
    if (!this.isHqUser) {
      this.commonService.restDetails$
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data) => {
          setTimeout(() => {
            this.restaurantDetails = data;
            this._cdr.detectChanges();
          }, 7000);
        });
    }
    this._localStorage.watch('restaurant_settings').subscribe((_) => {
      this.isKiosk = this.utilService.isKiosk();
      this.pricing = this.utilService.litePricing();
      this.isKioskChild = this.utilService.isKioskChild();
    });
    this.isKiosk = this.utilService.isKiosk();
    this.pricing = this.utilService.litePricing();
    this.isKioskChild = this.utilService.isKioskChild();
    const isMultiCashDrawerEnabled =
      this.utilService.isMultiCashDrawerEnabled();
    this.getBillingCounterName();
    if (isMultiCashDrawerEnabled && !this.billingCounterName) {
      this.getAllReceiptPrinter();
    }
  }

  private setTranslations(): void {
    this.subscription.add(
      this._translateService.get('TABLE_BOOKINGS').subscribe((translation) => {
        this.translationText = translation;
      })
    );
  }

  private getBillingCounterName(): void {
    this.subscription.add(
      this._counterDataService
        .getMappedBillingCounterName()
        .subscribe((mappedCounterName) => {
          this.billingCounterName = mappedCounterName;
        })
    );
  }

  watchHQFoodCourtEvents() {
    this._pusherEvent
      .watchEvent(EventList.ORDER_EVENT)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => this.onNewHQFoodCourtOrderEvent(event));
  }

  watchPusherEvents() {
    /*Watching order & table events on pusher*/

    this._pusherEvent
      .watchEvent(EventList.ORDER_EVENT)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) =>
        this.new_message_on_restaurant_topic(JSON.stringify(event))
      );

    this._pusherEvent
      .watchEvent(EventList.TABLE_EVENT)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) =>
        this.new_message_mqtt_table_event(JSON.stringify(event))
      );

    this._pusherEvent
      .watchEvent(EventList.TABLE_RESERVATION_EVENT)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => this.handleTableReservationEvents(event));
  }

  private handleTableReservationEvents(event) {
    const triggerEventTypes = [
      MtypeList.RESV_ACCEPTED,
      MtypeList.RESV_REJECTED,
      MtypeList.RESV_PENDING,
      MtypeList.RESV_CREATED,
    ];
    if (triggerEventTypes.includes(event.mtype)) {
      if (event.mtype !== MtypeList.RESV_REJECTED) {
        if (
          !Boolean(this.reservationSettings.auto_accept) &&
          (event.mtype === MtypeList.RESV_CREATED ||
            event.mtype === MtypeList.RESV_PENDING)
        ) {
          this._animationControlService.updateAnimationControl(
            ANIMATION_CONTROL_SUBJECT.TABLE_BOOKING,
            true
          );
        }

        if (
          (!Boolean(this.reservationSettings.auto_accept) &&
            event.mtype !== MtypeList.RESV_ACCEPTED) ||
          Boolean(this.reservationSettings.auto_accept)
        ) {
          this._audioService.playAudioOnNewOrder();
          this._msgService.showSuccess(
            this.translationText.TABLE_BOOKING_RECEIVED
          );
        }
      }
      this.getAllTableBookings();
    }
  }

  private getAllTableBookings() {
    const restId = this._localStorage.get('restaurant_id');
    const startEndEpochObj = this._tbHelperService.getStartEndEpochByDate(
      this.selectedDate
    );
    const params =
      this._tbApiService.getHttpParamsForAllTableBookings(startEndEpochObj);

    this._tbApiService.getAllTableBookingOrders(restId, params).subscribe(
      (res: any) => {
        this.tableBookingLength =
          (((res || {}).data || {}).aggregatedNumbers || {})
            .totalPendingBookings || 0;
      },
      (error) => {
        this._tbHelperService.apiErrorMsg(error);
      }
    );
  }

  private atleastOneProSubsChecker() {
    let pricing = false;
    try {
      const hqOutlets = JSON.parse(this._localStorage.get('ee_outlets') || '[]');
      const filteredOutlets = hqOutlets.filter((outlet) => {
        const plan = outlet?.settings?.global?.plan;
        return plan === membership.PRO || plan === membership.PRO_SUBS;
      });
      pricing = filteredOutlets?.length > 0;
    } catch (error) {
      console.error(error)
    }
    return pricing;
  }

  setValidURL() {
    this.validUrl = {
      report: this.authService.isURLAuthenticated(
        this.isHqUser ? 'hq/reports' : '/reports'
      ),
      'section-printer': this.authService.isURLAuthenticated('/section-counters'),
      loyalty: this.authService.isURLAuthenticated(
        this.isHqUser ? 'hq/loyalty' : '/loyalty'
      ),
      referral: this.authService.isURLAuthenticated(
        this.isHqUser ? 'hq/referral' : '/referral'
      ),
      inventory: this.authService.isURLAuthenticated(
        this.isHqUser ? 'hq/inventory' : '/inventory'
      ),
      promotion: this.authService.isURLAuthenticated(
        this.isHqUser ? 'hq/discounts' : '/discounts'
      ),
      'table-service': this.authService.isURLAuthenticated('/tableservice'),
      'table-bookings': this.authService.isURLAuthenticated('/table-bookings'),
      'ai-insights': this.authService.isURLAuthenticated('/ai-insights'),
      analytics: this.authService.isURLAuthenticated(
        this.isHqUser ? 'hq/analytics' : '/analytics'
      ),
      menu: this.authService.isURLAuthenticated('/menu'),
      ee_hq: this.authService.isURLAuthenticated('hq/dashboard'),
      hq_outlets: this.authService.isURLAuthenticated('hq/outlets'),
      billing: this.authService.isURLAuthenticated('hq/billing'),
      settlement: this.authService.isURLAuthenticated('hq/settlement'),
      'e-invoice': this.authService.isURLAuthenticated('hq/e-invoice'),
      staff_center:
        this.authService.isValidPermission('CAN_VIEW_HQ_STAFF_SETTINGS') ||
        this.authService.isValidPermission('CAN_VIEW_HQ_ROLES') ||
        this.authService.isValidPermission('CAN_VIEW_HQ_TABLE_SETTINGS'),
      pending_orders: true,
    };

    this.hqSideNavRoutes = [
      { name: 'ee_hq', isValid: this.validUrl.ee_hq, routeUrl: 'hq/dashboard' },
      {
        name: 'pending_orders',
        isValid: this.validUrl.pending_orders,
        routeUrl: 'hq/pending-orders',
      },
      {
        name: 'ee_outlets',
        isValid: this.validUrl.hq_outlets,
        routeUrl: 'hq/outlets',
      },
      {
        name: 'billing',
        isValid: this.validUrl.billing,
        routeUrl: 'hq/billing',
      },
      {
        name: 'reports',
        isValid: this.validUrl.report,
        routeUrl: 'hq/reports',
      },
      {
        name: 'analytics',
        isValid: this.validUrl.analytics,
        routeUrl: 'hq/analytics',
      },
      {
        name: 'staff_center',
        isValid: this.validUrl.staff_center,
        routeUrl: 'hq/staff-center',
      },
      {
        name: 'inventory',
        isValid: this.validUrl.inventory,
        routeUrl: 'hq/inventory',
      },
      {
        name: 'promotion',
        isValid: this.validUrl.promotion,
        routeUrl: 'hq/discounts',
      },
      {
        name: 'referral',
        isValid: this.validUrl.referral,
        routeUrl: 'hq/referral',
      },
      { name: 'no_permission', isValid: true, routeUrl: 'hq/no-permission' },
    ];
  }

  getRestaurantDetails() {
    const param = new FormData();
    param.append('restaurant_id', localStorage.getItem('restaurant_id'));
    this.apiService.getRestaurantDetails(param).subscribe((res) => {
      this.updateUI(res);
      if ((res || {}).status !== 0) {
        localStorage.setItem(
          'restaurant_currency',
          (res.data || {}).curr_sym || 'RM'
        );
        (res.data || {}).country_code &&
          this._lang.setCountry((res.data || {}).country_code);
        this.idCountry = (res.data || {}).country_code === country.id.country;
      }
    });
  }

  setRestSettingVar() {
    try {
      this.restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
    } catch (error) {
      this.restSettings = [];
    }
    try {
      this.isSettlement = this.restSettings['settlement']['visible'];
    } catch (error) {
      this.isSettlement = 0;
    }
    try {
      this.kioskCashReport = Boolean(
        this.restSettings['global']['kiosk_cash_report']
      );
    } catch (error) {
      this.kioskCashReport = false;
    }
    try {
      this.showLoyalty = Boolean(this.restSettings['global']['loyalty']);
    } catch (error) {
      this.showLoyalty = false;
    }
    try {
      this.isTableReservationEnabled = Boolean(
        this.restSettings['global']['show_resv_tab_on_pos']
      );
      if (this.isTableReservationEnabled) {
        this.subscription.add(
          this._animationControlService.tableBookingControl$.subscribe(
            (value) => {
              this.nudgeTableBooking = value;
            }
          )
        );
        this.getReservationSettings();
      }
    } catch (error) {
      this.isTableReservationEnabled = false;
    }
    try {
      this.showReferralProgram = this.utilService.getShowReferralProgram();
    } catch (error) {
      this.showReferralProgram = false;
    }
    if (this.hqService.isHqUser()) {
      this.isSettlement = 1;
      this.showLoyalty = true;
    }
    this.isLockEnabled = this.utilService.isLockEnabled();
    this.computePrepaidOrderSetting();
  }

  updateUI(res) {
    if (res.status) {
      this.restaurantDetails = res.data;
      localStorage.setItem('restaurant_address', res.data.address);
      localStorage.setItem(
        'restaurant_location',
        JSON.stringify(res.data.location)
      );
      localStorage.setItem('restaurant_type', res['data']['type']);
      this._localStorage.set(
        'restaurant_settings',
        JSON.stringify(res.data.settings)
      );
      localStorage.setItem(
        'restaurant_printer',
        this.utilService.getPrinterIp((res || {}).data)
      );
      this._localStorage.set(
        'default_bill_receipt_ip',
        ((res || {}).data || {}).printer
      );
      localStorage.setItem('restaurant_logo', res.data.logo);
      localStorage.setItem('restaurant_nameid', res.data.nameid);
      localStorage.setItem('dkick_code', JSON.stringify(res.data.dkick_code));
      this.setRestSettingVar();
      this.setValidURL();
    }
  }

  computePrepaidOrderSetting() {
    try {
      let rest_settings = (JSON.parse(
        localStorage.getItem('restaurant_settings')
      ) || {})['global'];
      rest_settings &&
        (this.isPrepaidOrderingEnabled =
          !!rest_settings['enable_pre_paid_order']);

      if (this.isPrepaidOrderingEnabled) {
        let prePaidSettings = (rest_settings || {}).pre_paid_order || 2;
        this.validPrepaidOrderTypes =
          this.utilService.getValidOrderTypes(prePaidSettings);
      }
    } catch {}
  }

  showTableLayout() {
    try {
      return (
        !!((JSON.parse(localStorage.getItem('restaurant_settings')) || {})[
          'global'
        ] || {})['table_layout'] && !this.isHqUser
      );
    } catch {
      return false;
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.showLoyalty = false;
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.subscription.unsubscribe();
  }

  // filter valid orders (remove unpaid delivery or takeaway orders (except placd by MM))
  calculateRunningOrders() {
    const restaurantNameId = localStorage.getItem('restaurant_nameid');
    const api = !this.isKiosk
      ? {
          function: () =>
            this.apiService.getCurrentOrders(
              this.restaurantid,
              '',
              '',
              this.isFoodCourtViewEnabled
                ? JSON.parse(localStorage.getItem('fc_rest_ids'))
                : [this.restaurantid]
            ),
        }
      : { function: () => this.apiService.getAllKioskOrders(restaurantNameId) };
    if (this.onGoingRequest == 0) {
      this.onGoingRequest = 1;
      api.function().subscribe(
        (res: any) => {
          this.onGoingRequest = 0;
          if ((res || {}).statusCode === 200) {
            this.validOrders = [];
            for (const order of res.data) {
              if (
                !(
                  order['order_type'] == 1 || order['order_type'] == 2
                ) ||
                order['order_by'] == 'MM' ||
                order['order_by'] == 'auto'
              ) {
                this.validOrders.push(order);
              }
            }
          }
        },
        (error: any) => {
          this.onGoingRequest = 0;
        }
      );
    }
  }

  url_changed(event) {
    if (event instanceof NavigationEnd) {
      this.currentUrl = event.url;
      this.restaurantid = localStorage.getItem('restaurant_id');
      this.isHqUser = this.hqService.isHqUser();
      this.setRestSettingVar();
    }
  }

  handleBlocked(tab) {
    if (this.isHqUser) {
      return false;
    }

    const unlockedTabsForEEMenuLeads = [
      'menu',
      'promotions',
      'helpCentre',
      'ee-hq',
      'outlets',
      'ai-insights'
    ];

    if (this.isEEFreeDigitalMenuLeads) {
      if (!unlockedTabsForEEMenuLeads.includes(tab)) {
        return true;
      } else {
        return false;
      }
    } else if (this._ciHelperService.isPlanExpired()) {
      const blockedFeatures = this._ciHelperService.getBlockedFeatures()
      return blockedFeatures.includes(tab);
    }
    return false;
  }

  tabclicked(tab) {
    if (this.handleBlocked(tab)) {
      const modalType = this.isEEFreeDigitalMenuLeads
        ? LOCKED_FEATURE_TYPE.FREE_MENU_LEADS
        : LOCKED_FEATURE_TYPE.EXPIRED;
      this._ciModalService.openLockedPlanModal({ type: modalType });
    }

    if (tab == 'orders') {
      this._eventTracker.easyeat_track_event('ORDERS_TAB_OPENED', {});
      this._eventTracker.easyeat_track_event('ORDERS_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
    } else if (tab == 'seating') {
      this._eventTracker.easyeat_track_event('SEATING_TAB_OPENED', {});
      this._eventTracker.easyeat_track_event('SEATING_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
    }  
     else if (tab == 'table-bookings') {
      this._eventTracker.easyeat_track_event('TABLE_RESERVATION_TAB_OPENED', {});
      this._eventTracker.easyeat_track_event('TABLE_RESERVATION_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
    } else if (tab == 'aiInsights') {
      this._eventTracker.easyeat_track_event('AI_INSIGHTS_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
    } else if (tab == 'tableservice') {
      this._eventTracker.easyeat_track_event('TABLE_SERVICE_TAB_OPENED', {});
      this._eventTracker.easyeat_track_event('TABLE_SERVICE_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
    } else if (tab == 'invoice') {
      this._eventTracker.easyeat_track_event('INVOICE_DISH_TAB_OPENED', {});
      this._eventTracker.easyeat_track_event('INVOICE_DISH_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
    } else if (tab == 'menu') {
      this._eventTracker.easyeat_track_event('MENU_DISHES_TAB_OPENED', {
        User_Email_ID: localStorage.getItem('email'),
        Restaurant_ID: localStorage.getItem('restaurant_id'),
        Restaurant_Name: localStorage.getItem('restaurant_nameid'),
      });
      this._eventTracker.easyeat_track_event('MENU_DISHES_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
      this._eventTracker.easyeat_track_event('VIEW_MENU-&-DISHES', {
        'Restaurant ID': localStorage.getItem('restaurant_id'),
      });
    } else if (tab == 'staff') {
      this._eventTracker.easyeat_track_event('STAFF_TABLES_TAB_OPENED', {});
      this._eventTracker.easyeat_track_event('STAFF_TABLES_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
    } else if(tab == 'e-invoice') {
      this._eventTracker.easyeat_track_event('E-INVOICE_TAB_OPENED', {});
      this._eventTracker.easyeat_track_event('E-INVOICE_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
    } else if (tab == 'section') {
      this._eventTracker.easyeat_track_event('SECTIONS_COUNTERS_TAB_OPENED', {});
      this._eventTracker.easyeat_track_event('SECTIONS_COUNTERS_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
      this._eventTracker.easyeat_track_event('SECTIONS_TAB_CLICKED', {});
    } else if (tab == 'loyaltyProgram') {
      this._eventTracker.easyeat_track_event('LOYALTY_TAB_OPENED', {});
      this._eventTracker.easyeat_track_event('LOYALTY_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
    } else if (tab == 'referralProgram') {
      this._eventTracker.easyeat_track_event('REFERRAL_TAB_OPENED', {});
      this._eventTracker.easyeat_track_event('REFERRAL_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
    } else if (tab == 'marketing') {
      this._eventTracker.easyeat_track_event('MARKETING_TAB_OPENED', {});
      this._eventTracker.easyeat_track_event('MARKETING_TAB_OPENED', {
        'Restaurant ID': this.restaurantid,
      });
    } else if (tab === 'promotions') {
      this._eventTracker.easyeat_track_event('Promotions_home', {});
    } else if (tab === 'helpCentre') {
      if (this.hqService.isHQActive) {
        this._eventTracker.easyeat_track_event('HQ_HelpCentre_Button_Clicked', {
          User_Email_ID: localStorage.getItem('email') || 'N/A',
          HQ_ID: localStorage.getItem('hq_id') || 'N/A',
          HQ_Opened: localStorage.getItem('ee_mall_name') || 'N/A',
        });
      } else {
        this._eventTracker.easyeat_track_event(
          'POS_HelpCentre_Button_Clicked',
          {
            restaurant_ID: localStorage.getItem('restaurant_id') || 'N/A',
            restaurant_Name: localStorage.getItem('restaurant_name') || 'N/A',
            User_Roles: localStorage.getItem('ee_user_type') || 'N/A',
            User_ID: 'N/A',
          }
        );
      }
    }

    // Remove the typeform NPS popover(if it exists) when we are visiting tab other than report
    var elem = document.getElementsByClassName('tf-v1-popover');
    if (elem.length == 1) {
      document.body.removeChild(elem[0]);
    }
  }

  async logout() {
    const user_type = localStorage.getItem('ee_user_type');
    this._eventTracker.easyeat_track_event('LOGOUT_CLICKED', {});
    this._ciHelperService.removeCollectionInfra();
    this._nudgeService.clearNudgeStorage();
    this._localStorage.clearSession();
    this.isUserLoggedInSn = false;
    this.user_type = '';
    this.change.emit('logout');
    this._eventTracker.easyeat_track_event('LOGOUT_CLICKED', {
      'Restaurant ID': this.restaurantid,
    });
    //React logout action
    try {
      let data = { action: 'logout' };
      let x = JSON.stringify(data);
      send_data(x);
    } catch (error) {}
    if (user_type === 'rest_hq_admin' || user_type === 'rest_hq_staff') {
      this.router.navigateByUrl('/hq/login');
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  sendCreateOrderReact(order_id) {
    if (this.isReactDevice) {
      try {
        let data = { action: 'order_created', order_id: order_id };
        let x = JSON.stringify(data);
        send_data(x);
      } catch (error) {}
    }
  }

  lock_screen() {
    this.router.navigateByUrl('/lock');
  }

  new_message_on_restaurant_topic(message) {
    let message_obj = JSON.parse(message);
    this.isValidOrder(message_obj);
  }

  isValidOrder(message) {
    let prepaidDineinEnabled = this.validPrepaidOrderTypes.includes(0);
    try {
      if (message['mtype'] === 'NOP') {
        if (
          message['data']['order_type'].toString() === '0' ||
          (message['data']['order_type'].toString() === '2' &&
            message['data']['takeaway_cash_enable'] === 1)
        ) {
          if (!(prepaidDineinEnabled && message['data']['order_type'] === 0)) {
            if (this.isAutoRefreshEnabled) {
              this._orderState.updateOrdersState(
                message,
                'from_pusher',
                message['mtype']
              );
            } else {
              !this._orderReactEvent.isOrderApplicableForAutoAccept(
                message['data']['order_type']
              ) && this._audioService.playAudioOnNewOrder(true);
              this._orderReactEvent.sendAcceptDeclineOrderReact(
                (message.data || {}).order_id || null,
                REACTEVENTS.ORDER_CREATE,
                { itr: message.data.itr }
              );
            }
          }
          // Commented for fallback solution
          this.calculateRunningOrders();
          this._orderReactEvent.sendAcceptDeclineOrderReact(
            (message.data || {}).order_id || null,
            REACTEVENTS.ORDER_CREATE,
            { itr: message.data.itr }
          );
        }
      } else if (message['mtype'] === 'OUP') {
        if (message['data']['order_type'].toString() === '0') {
          this.isAutoRefreshEnabled
            ? this._orderState.updateOrdersState(
                message,
                'from_pusher',
                message['mtype']
              )
            : !this._orderReactEvent.isOrderApplicableForAutoAccept(
                message['data']['order_type']
              ) && this._audioService.playAudioOnNewOrder(true);

          // Sending order update event to reactnative shell when order itr is updated
          (message.data || {}).action_type === 'itr_update' &&
            this._orderReactEvent.sendAcceptDeclineOrderReact(
              message['data']['order_id'],
              REACTEVENTS.ORDER_UPDATE,
              { itr: message['data']['itr'] }
            );
        }
      } else if (
        message['mtype'] === 'OCM' ||
        message['mtype'] === 'OCL' ||
        message['mtype'] === 'OCF'
      ) {
        this.calculateRunningOrders();
      } else if (message['mtype'] === 'PAYACK') {
        this.get_notification();
      } else if (message['mtype'] === 'PAY') {
        if (
          message['data']['order_type'].toString() === '1' ||
          message['data']['order_type'].toString() === '2'
        ) {
          // Commented for fallback solution
          // this.utilService.playAudioOnNewOrder();
          // Commented for some temporary time
          // this.isAutoRefreshEnabled ? this._orderState.updateOrdersState(message, 'from_pusher', message['mtype']) : this.utilService.playAudioOnNewOrder();
          // Will remove after backend fixes the PAY pusher issue
          !this.isAutoRefreshEnabled &&
            !this._orderReactEvent.isOrderApplicableForAutoAccept(
              message['data']['order_type']
            ) &&
            this._audioService.playAudioOnNewOrder(true);
          this.calculateRunningOrders();
          this._orderReactEvent.sendAcceptDeclineOrderReact(
            (message.data || {}).order_id || null,
            REACTEVENTS.ORDER_CREATE,
            { itr: message.data.itr }
          );
        } else if (
          message['data']['order_type'].toString() === '0' &&
          prepaidDineinEnabled
        ) {
          !this._orderReactEvent.isOrderApplicableForAutoAccept(
            message['data']['order_type']
          ) && this._audioService.playAudioOnNewOrder(true);
          this._orderReactEvent.sendAcceptDeclineOrderReact(
            (message.data || {}).order_id || null,
            REACTEVENTS.ORDER_CREATE,
            { itr: message.data.itr }
          );
        }
      }
      if (
        message['mtype'] === MtypeList.ORDER_CONFIRMED &&
        message['data']['platform'] == 'grabfood' &&
        message['data']['order_type'].toString() === '1'
      ) {
        this._audioService.playAudioOnNewOrder(true);
      }
    } catch (error) {}
  }

  // Pusher events handler for HQ Foodcourt orders
  onNewHQFoodCourtOrderEvent(message) {
    try {
      if (message['mtype'] === MtypeList.NEW_ORDER_PLACED) {
        if (
          message['data']['order_type'].toString() === '0' ||
          (message['data']['order_type'].toString() === '2' &&
            message['data']['takeaway_cash_enable'] === 1)
        ) {
          this._audioService.playAudioOnNewOrder();
          this.calculateAllFoodCourtOrders();
        }
      } else if (message['mtype'] === MtypeList.ORDER_UPDATED) {
        if (message['data']['order_type'].toString() === '0') {
          this._audioService.playAudioOnNewOrder();
        }
      } else if (
        message['mtype'] === MtypeList.ORDER_COMPLETED ||
        message['mtype'] === MtypeList.ORDER_CANCELED
      ) {
        this.calculateAllFoodCourtOrders();
      } else if (message['mtype'] === MtypeList.PAYMENT_SUCCESS) {
        if (
          message['data']['order_type'].toString() === '1' ||
          message['data']['order_type'].toString() === '2'
        ) {
          this._audioService.playAudioOnNewOrder();
          this.calculateAllFoodCourtOrders();
        }
      } else if (message['mtype'] === MtypeList.ITEM_PREPARED) {
        this._audioService.playAudioOnNewOrder();
      }
    } catch {}
  }

  calculateAllFoodCourtOrders() {
    if (this.onGoingRequest == 0) {
      this.onGoingRequest = 1;
      this.apiService
        .getOrdersForMultipleRestaurants(
          this.allOutletListIds[0],
          '',
          '',
          this.allOutletListIds,
          1
        )
        .subscribe(
          (response: any) => {
            this.onGoingRequest = 0;
            if (response.statusCode === 200) {
              const {
                food_is_ready_count,
                preparing_order_count,
                scheduled_orders_count,
                to_be_accepted_count,
              } = response.data;
              this.allFoodCourtOrderCount =
                (food_is_ready_count || 0) +
                (preparing_order_count || 0) +
                (scheduled_orders_count || 0) +
                (to_be_accepted_count || 0);
            }
          },
          (error: any) => {
            this.onGoingRequest = 0;
          }
        );
    }
  }

  new_message_mqtt_table_event(message) {
    message = JSON.parse(message);
    if (message['mtype'] === 'USM' || message['mtype'] === 'PAY' || message['mtype'] === 'CSH') {
      if (message['mtype'] !== 'CSH' && message.data?.service_type === 'collect cash') {
        this._audioService.playAudioOnPaymentEvent(1);
      } else if (message['mtype'] !== 'CSH') {
        this._audioService.playAudioOnTableEvent(1);
      }
      this.get_notification();
    }
  }
  hasRestDetailsViewPermission() {
    if (this.isHqUser) {
      return this.validUrl['hq_outlets'];
    } else {
      let allowedPermissions = this.navHeads.filter((x) => {
        if (this.hasValidViewPermission(x.permission)) return true;
        else return false;
      });
      return allowedPermissions.length;
    }
  }

  hasValidViewPermission(permission) {
    return this.authService.isValidPermission(permission);
  }

  isUsrLoggedIn() {
    if (localStorage.getItem('token')) {
      return true;
    } else {
      return false;
    }
  }

  get_restaurant_name() {
    if (localStorage.getItem('token')) {
      return localStorage.getItem('restaurant_name');
    } else {
      return '';
    }
  }

  get_user_type() {
    if (localStorage.getItem('token')) {
      return localStorage.getItem('user_type');
    } else {
      return '';
    }
  }

  get_notification() {
    const formData: any = new FormData();
    formData.append('token', localStorage.getItem('token'));

    // [PHP_TO_NEST_ROLLOUT] routed through ApiService so migration switch applies centrally
    this.apiService
      .getTableNotifications(formData)
      .subscribe((data: any) => {
        this.populate_notification(data);
      },
      (error) => {
        console.error("Error while fetching notifications count", error?.message);
      }
    );
  }

  populate_notification(notifications) {
    this.allNotification = [];
    if (notifications['status'] === 1) {
      for (const notification of notifications['data']) {
        if (notification['ack'] === 0) {
          this.allNotification.push({
            username: notification['sender_name'],
            floor_name: notification['data']['floor_name'],
            table_no: notification['data']['table_no'],
            message_id: notification['mid'],
            order_id: notification['data']['order_id'],
            time_stamp: parseInt(notification['time_stamp']),
            time_text: notification['time_text'],
          });
        }
      }
    }
  }

  onAppSettingsClick() {
    try {
      let data = { action: 'app_setting' };
      let x = JSON.stringify(data);
      send_data(x);
    } catch (error) {}
  }

  onCollapseToggleClick() {
    this.isCollapsed = !this.isCollapsed;
    localStorage.setItem('sidenavCollapsed', '' + this.isCollapsed);
    this.onToggleCollapse.emit({ isCollapsed: this.isCollapsed });
  }

  private getAllReceiptPrinter() {
    const params = {
      restId: this._localStorage.get('restaurant_id'),
      deviceId: this.utilService.getDeviceUID(),
    };
    this.apiService
      .getAllReceiptPrinters(params.restId, params.deviceId)
      .subscribe(
        (response: any) => {
          if (response?.statusCode === 200) {
            this._counterDataService.setBillingCounterInfo(response?.data);
          } else {
            console.error(response?.data?.message);
          }
        },
        (error) => {
          console.error(error?.error);
        }
      );
  }
}